import store from '@/store'
import * as types from '@/store/types'
import * as constants from '@/store/constants'
import SimpleVueValidator from 'simple-vue-validator';
const Validator = SimpleVueValidator.Validator;

const commonMixin = {

    validators: {
     purposeId: function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
     detailsNotification: function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      }, 
     'purposeOthers, purposeId': function (purposeOthers, purposeId) {
        return Validator.custom(function () {
          if ( store.state.modified && purposeId === constants.PURPOSE_OTHERS && Validator.isEmpty(purposeOthers) ) {
              return 'This is a required field.'
          }
        })
      }
    }
  }

export default commonMixin


// WEBPACK FOOTER //
// ./src/mixins/validators/Common-validators.js